import { InteractiveStory } from "./storyTypes";

const storyFile = (fileName: string) =>
  `https://www.pkps.edu.hk/eng/Ebook2/${fileName}`;

export const greatStaircaseRelayStory: InteractiveStory = {
  id: "great-staircase-relay",
  title: "The Great Staircase Relay",
  startSceneId: "cover",
  scenes: [
    {
      id: "cover",
      layout: "cover",
      image: storyFile("cover.jpeg"),
    },
    {
      id: "page-1",
      layout: "spread",
      image: storyFile("page3.jpeg"),
      text: `Leo came home after school. He lived in a tall building in Hong Kong. Oh no! The lift was broken.

Grandma stood in the lobby. She held two heavy bags of vegetables. "The bags are too heavy," said Grandma. "I cannot walk up the stairs!"`,
    },
    {
      id: "page-2",
      layout: "spread",
      image: storyFile("page2.jpeg"),
      text: `Leo wanted to help. He called his good friends, Abby and Tim. "Let's work together!" said Leo.

Leo, Abby, and Tim stood on different floors on the stairs. They passed the bags from hand to hand. Up, up, up went the bags!`,
    },
    {
      id: "page-3",
      layout: "spread",
      image: storyFile("page1.jpeg"),
      text: `There was a big watermelon. It was very heavy! Tim could not lift it alone. "Let me help you!" said Leo.

"One, two, three, lift!" they shouted. Together, Leo and Tim carried the heavy watermelon up the stairs.`,
    },
    {
      id: "page-4",
      layout: "spread",
      image: storyFile("page4.jpeg"),
      text: `Soon, all the bags were outside the apartment doors. Grandma and the neighbours were very happy. They clapped for the kids.

Grandma gave Leo, Abby, and Tim cold lemon tea to drink. Leo smiled. "Working together makes hard work easier!" he said.`,
    },
    {
      id: "song",
      layout: "lyrics",
      heading: "Up the Stairs Together",
      image: storyFile("cover.jpeg"),
      audio: storyFile("song.mp3"),
      text: "Listen and sing the song with your parents.",
      lyrics: [
        {
          heading: "Intro",
          lines: [
            "(Are you ready?) Yes, we are!",
            "(Can we do it?) Yes, we can!",
            "One, two, three, four, here we go!",
            "Step by step, watch us grow!",
          ],
        },
        {
          heading: "Verse 1",
          lines: [
            "The lift is stuck, the bags are heavy,",
            "But we have a plan, we are ready!",
            "Mei takes the left, Leo the right,",
            "We carry the load with all our might!",
          ],
        },
        {
          heading: "Chorus",
          lines: [
            "Up the stairs, one by one,",
            "Getting work nicely done!",
            "Pass the bag, help a friend,",
            "Working 'til the very end!",
          ],
        },
        {
          heading: "Verse 2",
          lines: [
            "Lok's on the stairs with a big smile,",
            "We've been climbing for quite a while.",
            "Count the floors and pass them fast,",
            "This hard work is not gonna last!",
          ],
        },
        {
          heading: "Chorus",
          lines: [
            "Up the stairs, one by one,",
            "Getting work nicely done!",
            "Pass the bag, help a friend,",
            "Working 'til the very end!",
          ],
        },
        {
          heading: "Outro",
          lines: [
            "We made it to the very top!",
            "Our helping hands will never stop!",
            "(Yay!) Go team, go!",
            "Together is the way to grow!",
          ],
        },
      ],
    },
  ],
};
